import React from 'react'
import styles from './styles.css'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import Show from './Show'
import Edit from './Edit'

export default class Field extends React.Component {
  static propTypes = {
    field: PropTypes.object,
    height: PropTypes.number,
    page: PropTypes.object,
    onChange: PropTypes.func,
    sign: PropTypes.bool
  }

  state = {}

  static fragment = gql`
    fragment signDocumentField on Document {
      fields {
        id
        filler
        type
        value {
          text
          signatureId
          checked
        }
        page
        label
        x
        y
        required
        width
        height
        iAmFiller
        name
        validation
        textSize
      }
    }
  `

  getStyle() {
    var currentWidth = this.props.height * this.props.page.width / this.props.page.height
    var currentHeight = this.props.height
    if (this.props.field.textSize) {
      if (this.props.field.textSize === 'medium') {
        currentHeight = currentHeight * 1.5
      } else if (this.props.field.textSize === 'large') {
        currentHeight = currentHeight * 2
      }
    }
    return {
      position: 'absolute',
      top: this.props.field.y * 100 + '%',
      left: this.props.field.x * 100 + '%',
      width: (this.state.width || this.props.field.width) * currentWidth,
      height: (this.state.height || this.props.field.height) * currentHeight

    }
  }

  render() {
    console.log('IAMFiller' + this.props.field.iAmFiller)
    return (
      <span className={styles.container} style={this.getStyle()}>
        {this.props.field.iAmFiller && this.props.sign ? (
          <Edit {...this.props} />
        ) : (
          <Show {...this.props} />
        )}
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/index.js